interface EdgeDataItem {
  id?: string;
  text?: string;
  label?: string;
}

function resolveEdgeField(
  plain: unknown,
  edgeData: unknown,
  separator = '\n\n',
): string {
  if (Array.isArray(edgeData) && edgeData.length > 0) {
    const concatenated = (edgeData as EdgeDataItem[])
      .map(item => (typeof item?.text === 'string' ? item.text : ''))
      .filter(text => text.length > 0)
      .join(separator);
    if (concatenated.length > 0) return concatenated;
  }
  if (typeof plain === 'string') return plain;
  return '';
}

export { resolveEdgeField };
